// extracted by mini-css-extract-plugin
module.exports = {"hubtype-webchat-component":"HubtypeWebchat_hubtype-webchat-component__NuETz","wrapper":"HubtypeWebchat_wrapper__bc13f","image-bubble":"HubtypeWebchat_image-bubble__AO_KZ"};